import React from "react";

const SidebarSublistItem = (props) => {
  const { title } = props;

  return (
    <div className="SidebarSublistItem fs-14">
      <span className="SidebarSublistItem__link-title">{title}</span>
    </div>
  );
};

export default SidebarSublistItem;
